import { TranslationMap } from '@trimble-gcs/i18n-types';

export function recycleBinOptionsPanelTranslations() {
  return {
    restore: {
      button: {
        text: $localize`:@@config.recycleBin.options.restore.button:Restore`,
        desc: 'Text for the restore button.',
      },
      tooltip: {
        text: $localize`:@@config.recycleBin.options.restore.tooltip:Restore Data`,
        desc: 'Tooltip for the restore button.',
      },
    },
    delete: {
      button: {
        text: $localize`:@@config.recycleBin.options.delete:Delete`,
        desc: 'Text for the delete button.',
      },
      tooltip: {
        text: $localize`:@@config.recycleBin.options.delete.tooltip:Permanently Delete Data`,
        desc: 'Tooltip for the delete button.',
      },
    },
  } satisfies TranslationMap;
}
